export default __webpack_public_path__ + "static/media/riot-and-sora.f9020a11.jpg";